import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  PlanOutboundOutreachTable,
  PlanOutboundRemarksTable,
  PlanOutboundServicesTable,
} from '@components/Order/Numbers/Tables';
import { Page500 } from '@containers/ErrorPages';
import { planDetailsApi } from '@reducers/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const OutboundServicesTab = () => {
  const { showState } = useSelector((state) => state.plan.planInfo);
  const queryArg =
    showState.currentPlan.id && showState.currentPlan.type
      ? { ...showState.currentPlan }
      : skipToken;
  const { data, isLoading, isFetching, isError } =
    planDetailsApi.useGetOutboundServicesQuery(queryArg);

  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }

  return (
    <>
      <Row>
        <Col md={6}>
          <PlanOutboundOutreachTable data={[data]} />
        </Col>
        <Col md={6}>
          <PlanOutboundServicesTable data={[data]} />
        </Col>
      </Row>
      <Row>
        <Col>
          <PlanOutboundRemarksTable data={[data]} />
        </Col>
      </Row>
    </>
  );
};
